import CodeIcon from '@mui/icons-material/Code';
import {Fab} from '@mui/material';
import PropTypes from 'prop-types';
import React, {useRef, useState} from 'react';

const CompareSlider = props => {
  const handleRef = useRef(null);
  const [isDragging, setIsDragging] = useState(false);

  const onMove = clientX => {
    const node = handleRef.current;
    if (node) {
      const rect = node.offsetParent.getBoundingClientRect();
      const position = (clientX - rect.left) / rect.width;
      const clamped = Math.max(0, Math.min(1, position));
      props.onChange(clamped);
    }
  };

  const onMouseMove = event => {
    onMove(event.clientX);
  };

  const onMouseUp = () => {
    setIsDragging(false);
    window.removeEventListener('mousemove', onMouseMove);
    window.removeEventListener('mouseup', onMouseUp);
  };

  const onTouchMove = event => {
    event.preventDefault();
    onMove(event.changedTouches[0].clientX);
  };

  const onMouseDown = () => {
    setIsDragging(true);
    window.addEventListener('mousemove', onMouseMove);
    window.addEventListener('mouseup', onMouseUp);
  };

  const onTouchEnd = () => {
    setIsDragging(false);
    document.removeEventListener('touchmove', onTouchMove);
    document.removeEventListener('touchend', onTouchEnd);
  };

  const onTouchStart = () => {
    setIsDragging(true);
    document.addEventListener('touchmove', onTouchMove, {passive: false});
    document.addEventListener('touchend', onTouchEnd);
  };

  return (
    <Fab
      color="primary"
      ref={handleRef}
      size="small"
      disableRipple
      onMouseDown={onMouseDown}
      onTouchStart={onTouchStart}
      sx={theme => ({
        position: 'absolute',
        top: `calc(50% - ${theme.spacing(2.5)})`,
        left: `calc(${props.position * 100}% - 2px)`,
        transform: 'translateX(-50%)',
        pointerEvents: 'all',
        cursor: isDragging ? 'grab' : 'pointer',
      })}
    >
      <CodeIcon />
    </Fab>
  );
};

CompareSlider.propTypes = {
  position: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default CompareSlider;
